// extracted by mini-css-extract-plugin
module.exports = {"paper":"paper-1ogu9","additional":"additional-3vil5"};